// import React from "react";
// import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip } from "recharts";

// const data = [
//   { name: "Jan", profit: 80, loss: 60 },
//   { name: "Feb", profit: 70, loss: 50 },
//   { name: "Mar", profit: 90, loss: 40 },
//   { name: "Apr", profit: 100, loss: 80 },
//   { name: "May", profit: 80, loss: 60 },
//   { name: "Jun", profit: 40, loss: 20 },
//   { name: "Jul", profit: 70, loss: 30 },
//   { name: "Aug", profit: 90, loss: 60 },
//   { name: "Sep", profit: 75, loss: 55 },
// ];

// const RevenueChart: React.FC = () => {
//   return (
//     <div style={{ width: "100%", height: 300 }}>
//       <ResponsiveContainer>
//         <BarChart data={data} margin={{ left: -10 }}>
//           <CartesianGrid strokeDasharray="3 3" vertical={false} />
//           <XAxis dataKey="name" />
//           <YAxis />
//           <Tooltip />
//           <Bar dataKey="profit" stackId="a" barSize={18} fill="#6b8cff" radius={[6,6,0,0]} />
//           <Bar dataKey="loss" stackId="a" barSize={18} fill="#dbe7ff" radius={[6,6,0,0]} />
//         </BarChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default RevenueChart;






import React, { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import { IOrder } from "../utils/interface";

interface Props {
  orders?: IOrder[];
}

const RevenueChart: React.FC<Props> = ({ orders = [] }) => {
  const [chartData, setChartData] = useState<
    { name: string; revenue: number }[]
  >([]);

  useEffect(() => {
    if (!orders || orders.length === 0) return;

    const monthlyRevenue: Record<string, number> = {};

    orders.forEach((order) => {
      if (!order?.createdAt || !order?.totalAmount) return;
      const month = new Date(order.createdAt).toLocaleString("default", {
        month: "short",
      });
      monthlyRevenue[month] = (monthlyRevenue[month] ?? 0) + order.totalAmount;
    });

    // Format data for Recharts
    const formatted = Object.entries(monthlyRevenue).map(([month, revenue]) => ({
      name: month,
      revenue,
    }));

    // Sort months in calendar order
    const monthOrder = [
      "Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",
    ];
    formatted.sort(
      (a, b) => monthOrder.indexOf(a.name) - monthOrder.indexOf(b.name)
    );

    setChartData(formatted);
  }, [orders]);

  const totalRevenue = orders.reduce(
    (sum, order) => sum + (order?.totalAmount ?? 0),
    0
  );

  return (
    <div className="card p-3">
      <h5 className="mb-3">
        Total Revenue: ₦{totalRevenue.toLocaleString()}
      </h5>

      {chartData.length === 0 ? (
        <p>No revenue data available.</p>
      ) : (
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer>
            <BarChart data={chartData} margin={{ left: -10 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar
                dataKey="revenue"
                barSize={18}
                fill="#6b8cff"
                radius={[6, 6, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default RevenueChart;
